import React, { useEffect, useState } from 'react';
import { useTranslation } from '../App';
import EnquiryForm from './EnquiryForm';

const Banner = () => {
  const [isActive, setIsActive] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const t = useTranslation();

  useEffect(() => {
    const interval = setInterval(() => {
      setIsActive(prev => !prev);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="banner" id="home">
      <div className="active">
        <span className={`green ${isActive ? 'myClass' : ''}`}>•</span>
        <span className="active-text">{t.banner.status}</span>
      </div>
      
      <video className="vid-bg" autoPlay loop muted playsInline width="100%" crossOrigin="anonymous" preload="auto" poster="/assets/s3.jpeg">
        <source src="/assets/bg.mp4" type="video/mp4" />
      </video>

      <div className="banner-content">
        <h1>{t.banner.heading}</h1>
        <div className="cta">
          <p>{t.banner.description}</p>
          <button onClick={() => setShowForm(true)} className="banner-btn">
            {t.banner.button} <img src="/assets/icons/right-arrow.png" width="25px" alt="" />
          </button>
        </div>
      </div>
      <EnquiryForm isOpen={showForm} onClose={() => setShowForm(false)} />
    </section>
  );
};

export default Banner;